<script setup lang="ts">
withDefaults(defineProps<{
  id: string
  w: string
}>(), {
  id: 'discovery',
  w: 'grid g-1'
})
</script>

<template>
  <Frame class="sec-sphere-content" :class="id" :w="w">
    <slot />
  </Frame>
</template>

<style lang="scss" scoped>

</style>